export default __webpack_public_path__ + "static/media/Photo 3 - MR - Béton.cd413b6c.png";